import React from 'react'
import styled from 'styled-components'
import Burger from './Burger';

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: clamp(10px, 4vw, 20px);
  background-color: white;

  .author-name {
    white-space: nowrap;  
    color: #8a8affff;
    font-weight: bold; 
    font-size: clamp(2.5rem, 7vw, 4.5rem);
    font-family: 'MedievalSharp', serif;
  }
`;

const Navbar = () => {
  return (
    <Nav>

        <div className="author-name">ANNA MIKI</div>
        
        <Burger />
        
    </Nav>
  )
}

export default Navbar;
